import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7d39ce40"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "solution-service__wrap"
};
const _hoisted_2 = {
  class: "solution-service__content"
};
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<h1 class=\"solution-service__title\" data-v-7d39ce40>百度数十年广告经验，精准营销解决方案</h1><div class=\"solution-service__des\" data-v-7d39ce40><p data-v-7d39ce40>百度在广告领域有着数十年的深耕，出海易借助百度广告的优势，始终用数据和效果说话，旨在让世界任何</p><p data-v-7d39ce40>一个角落的企业都可以把产品卖向全球。出海易汇集全球主流媒介Google、Facebook、LinkedIn等流量资</p><p data-v-7d39ce40>源，是集搜索营销、社媒营销、视频营销、品牌营销、AI智能营销于一体的多渠道智能营销服务。</p></div><div class=\"solution-service__line\" data-v-7d39ce40></div><h1 class=\"solution-service__title\" data-v-7d39ce40>我们的服务</h1><div class=\"solution-service__subTitle\" data-v-7d39ce40>一对一顾问式服务，定制化投放策略，资深团队专业操盘，托管代运营</div>", 5);
const _hoisted_8 = {
  class: "solution-service__customize"
};
const _hoisted_9 = {
  class: "solution-service__customize-title"
};
const _hoisted_10 = {
  class: "solution-service__customize-des"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customizeList, (row, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "solution-service__customize-row"
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (col, i) => {
      return _openBlock(), _createElementBlock("div", {
        key: `${index}_${i}`,
        class: "solution-service__customize-col"
      }, [_createElementVNode("i", {
        class: "solution-service__customize-icon",
        style: _normalizeStyle({
          backgroundImage: `url(${col.icon})`
        })
      }, null, 4), _createElementVNode("h2", _hoisted_9, _toDisplayString(col.title), 1), _createElementVNode("div", _hoisted_10, _toDisplayString(col.desc), 1)]);
    }), 128))]);
  }), 128))])])]);
}